import { resolveLanguageList } from '../tutorialSlug/utils/resolveLanguageList'
import type { TutorialSection } from '../types'
import { pickDefaultQuickStartLanguage } from '../utils/pickDefaultQuickStartLanguage'

import { documentationArticleUrlPath } from './documentationArticleUrlPath'
import { documentationNavUrlPathForSection } from './documentationNavUrlPathForSection'

/**
 * When a multi-language article is accessed without a language suffix,
 * returns the canonical redirect path including the default language.
 */
export function resolveDocumentationSlugFallback(slug: string[], sections: TutorialSection[]): string | null {
  if (slug.length === 0) return null

  const joined = slug.join('/')

  const match = sections.find((s) => {
    const langs = resolveLanguageList(s)
    return langs.length > 1 && documentationArticleUrlPath(s.path) === joined
  })

  if (match) {
    const langs = resolveLanguageList(match)
    const priorityLang = pickDefaultQuickStartLanguage(langs)
    return documentationNavUrlPathForSection(match, priorityLang)
  }

  if (slug.length >= 2) {
    const articlePath = slug.slice(0, -1).join('/')
    const mergedArticle = sections.find((s) => {
      const langs = resolveLanguageList(s)
      return langs.length <= 1 && documentationArticleUrlPath(s.path) === articlePath
    })
    if (mergedArticle) {
      return documentationNavUrlPathForSection(
        mergedArticle,
        mergedArticle.defaultLanguage ?? resolveLanguageList(mergedArticle)[0] ?? 'default'
      )
    }
  }

  return null
}
